import type { PlcManufacturerCodeLibrary } from "./types";

export const mitsubishiCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "mitsubishi",
  manufacturer_name: "Mitsubishi Electric",
  codes: [
    {
      id: "mitsubishi-q-2200-missing-para",
      manufacturer_id: "mitsubishi",
      series_id: "melsec-q",
      model: null,
      code: "2200",
      code_type: "CPU Error",
      title_ar: "MISSING PARA",
      description_ar: "خطأ MISSING PARA يعني أن الـCPU ما لقى Parameters مطلوبة بالحالة الموثقة، ومنها حالات boot/parameter memory المحددة بالـQnUCPU.",
      symptoms: ["CPU error 2200", "المشروع أو الـparameters ما يبدن بصورة طبيعية"],
      causes: ["Parameter file مفقود بالمكان المتوقع", "Boot setting/Memory Card configuration مو مطابق"],
      checks: [
        {
          step: 1,
          action: "راجع ملفات Parameters وBoot Settings بــGX Works2/البرنامج المناسب.",
          expected: "ملفات الـparameters موجودة بالذاكرة الصحيحة.",
          faulty: "Parameter file مفقود أو هدف الـboot مو صحيح.",
        }
      ],
      solutions: ["أعد كتابة الـparameters للمكان الصحيح.", "راجع إعدادات Memory Card/SD والـboot قبل إعادة التشغيل."],
      severity: "عالية",
      source_title: "Mitsubishi Electric QnUCPU User's Manual (Function Explanation, Program Fundamentals)",
      source_section: "MISSING PARA (error code 2200)",
      keywords: ["Mitsubishi", "MELSEC-Q", "2200", "MISSING PARA"],
    },
    {
      id: "mitsubishi-iqr-mes-1800h",
      manufacturer_id: "mitsubishi",
      series_id: "melsec-iq-r",
      model: null,
      code: "1800H",
      code_type: "Module Error",
      title_ar: "Unsupported device error",
      description_ar: "موديول MES ضمن MELSEC iQ-R لقى جهاز غير مدعوم ضمن access route.",
      symptoms: ["MES Interface Module يسجل 1800H", "الوصول للجهاز الهدف يفشل"],
      causes: ["جهاز غير مدعوم موجود بمسار الوصول"],
      checks: [
        {
          step: 1,
          action: "راجع Access Route والأجهزة المعرفة بإعداد MES Interface Module.",
          expected: "كل جهاز بالمسار مدعوم.",
          faulty: "أكو جهاز غير مدعوم ضمن المسار.",
        }
      ],
      solutions: ["غيّر مسار الوصول أو الجهاز إلى تكوين مدعوم.", "راجع Device Type وإعداد Target Device."],
      severity: "عالية",
      source_title: "Mitsubishi Electric MELSEC iQ-R MES Interface Module User's Manual",
      source_section: "Error Code List: 1800H Unsupported device error",
      keywords: ["Mitsubishi", "iQ-R", "MES", "1800H"],
    },
    {
      id: "mitsubishi-iqr-mes-1801h-1802h",
      manufacturer_id: "mitsubishi",
      series_id: "melsec-iq-r",
      model: null,
      code: "1801H-1802H",
      code_type: "Module Error",
      title_ar: "Incorrect target error",
      description_ar: "إعدادات Target Device داخل MES Interface Module بيها قيم غير صحيحة.",
      symptoms: ["MES module يسجل 1801H أو 1802H", "الوصول للهدف ما يكتمل"],
      causes: ["قيم Target Device Settings غير صحيحة"],
      checks: [
        {
          step: 1,
          action: "راجع Target Device Settings عنصر عنصر.",
          expected: "القيم مطابقة للجهاز والمسار.",
          faulty: "أكو قيمة Target مو صحيحة.",
        }
      ],
      solutions: ["صحح Target Device Settings.", "أعد التحقق من الوصول بعد الكتابة للموديول."],
      severity: "عالية",
      source_title: "Mitsubishi Electric MELSEC iQ-R MES Interface Module User's Manual",
      source_section: "Error Code List: 1801H to 1802H Incorrect target error",
      keywords: ["Mitsubishi", "iQ-R", "MES", "1801H", "1802H"],
    },  ],
};
